import React from "react";
import { Tooltip } from "@mui/material";
import styles from "./index.module.scss";
import search from "../../../../assets/images/search.svg";
import clearIcon from "../../../../assets/images/close-icon.svg";

interface ToolBarProps {
  selectedOption: {
    label: string;
    value: string | number;
    data: any;
  };
  isDropdownOpen: boolean;
  searchText: string;
  searchValue: { open: boolean; value: string };
  sessions: any[];
  setIsDropdownUserList: (value: boolean) => void;
  setSelectedOption: (option: any) => void;
  setDropdownAllocatedSessionId: (id: any) => void;
  setIsDropdownOpen: (value: boolean) => void;
  loadUsers: (offset: number, reset: boolean, appliedfilters?: any, filterItem?: any) => void;
  setSelectedSidebarItem: (value: string) => void;
  handleDropdownSessionSelect: (session: any) => void;
  setSearchText: (text: string) => void;
  setFinalSearchText: (text: string) => void;
  handleSearch: (query: string) => void;
  setSearchValue: (value: { value: string; open: boolean }) => void;
}

export const PreferenceMobileScroll: React.FC<ToolBarProps> = ({
  selectedOption,
  // searchText,
  // searchValue,
  sessions,
  setIsDropdownUserList,
  setSelectedOption,
  setDropdownAllocatedSessionId,
  loadUsers,
  setSelectedSidebarItem,
  handleDropdownSessionSelect,
  // setSearchText,
  // setFinalSearchText,
  // handleSearch,
  // setSearchValue,
}) => {
  const handleAllClick = () => {
    setIsDropdownUserList(false);
    setSelectedOption({
      label: "All",
      value: "all",
      data: "",
    });
    setDropdownAllocatedSessionId(null);
    setSelectedSidebarItem("total");
    loadUsers(0, true, {}, {
      kpiFilter: "all",
      approvalStatus: "all",
    });
  };

  const handleUnassignedClick = () => {
    setIsDropdownUserList(false);
    setSelectedOption({
      label: "Unassigned",
      value: "registered",
      data: "",
    });
    setSelectedSidebarItem("total_unallocated");
    setDropdownAllocatedSessionId(null);
    loadUsers(0, true, {}, "total_unallocated");
  };

  const handleSessionClick = (session: any) => {
    handleDropdownSessionSelect(session);
    setSelectedSidebarItem(`${session.kpiFilter}_total`);
  };

  const handleSwapRequestClick = () => {
    handleDropdownSessionSelect("Swap Request");
    setSelectedSidebarItem("total");
  };

  const isSelected = (value: string) => {
    console.log("listsssss ", selectedOption.label);
    return selectedOption?.value === value ||
      selectedOption?.label?.toLowerCase() === value.toLowerCase();
  };
  console.log("sessions list ", selectedOption.label);
  return (
    <div className={styles.toolbarContainer}>
      <div className={styles.horizontalScrollContainer}>
        <div className={styles.scrollableContent}>
          <div
            className={`${styles.horizontalItem} ${isSelected("all") ? styles.selectedItem : ""
              }`}
            onClick={handleAllClick}
          >
            All
          </div>
          <div
            className={`${styles.horizontalItem} ${isSelected("registered") || isSelected("Unassigned") ? styles.selectedItem : ""}`}
            onClick={handleUnassignedClick}
          >
            Unassigned
          </div>
          {sessions.map((session) => (
            <div
              key={session.id}
              className={`${styles.horizontalItem} ${isSelected(session.name) ? styles.selectedItem : ""
                }`}
              onClick={() => handleSessionClick(session)}
            >
              {session.name !== "Hold" && session.name !== "YTD"
                ? `${session.name} blessed`
                : session.name}
            </div>
          ))}
          <div
            className={`${styles.horizontalItem} ${isSelected("Swap Request") ? styles.selectedItem : ""
              }`}
            onClick={handleSwapRequestClick}
          >
            Swap requests
          </div>
        </div>
      </div>
      {/* <div className={styles.searchContainer}>
        {searchValue.open && (
          <div className={styles.search} data-testid="search-container">
            <input
              type="text"
              className={styles.searchInput}
              autoFocus
              value={searchText}
              placeholder="Search seeker with name"
              onChange={(e) => setSearchText(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(e.currentTarget.value);
                }
              }}
              data-testid="search-input"
            />
            {searchText && (
              <button
                className={styles.clearIcon}
                onClick={() => {
                  setSearchText("");
                  setFinalSearchText("");
                }}
                data-testid="clear-button"
              >
                <img src={clearIcon} alt="clear" data-testid="clear-icon" />
              </button>
            )}
          </div>
        )}
        <Tooltip title="Search" arrow>
          <button className={styles.searchIcon} data-testid="search-button">
            <img
              src={search}
              alt="search"
              data-testid="search-icon"
              onClick={() =>
                setSearchValue({ value: "", open: !searchValue.open })
              }
            />
          </button>
        </Tooltip>
      </div> */}
    </div>
  );
};